import React, { useEffect } from "react";
import CategoryHeader from "../../components/Category/CategoryHeader";
import SearchCountNumber from "../../components/Layout/SearchCountNumber";
import Pagination from "../../components/Layout/Pagination";
import { Col, Container, Row } from "react-bootstrap";
import SidebarFilter from "../../components/Layout/SidebarFilter";
import CardProductContainer from "../../components/Products/CardProductContainer";
import UseViewSearchProducts from "../../CustomHooks/Products/UseViewSearchProducts";
import NavBar from "../../components/Layout/NavBar";
import Footer from "../../components/Layout/Footer";

const ShopProducts = () => {

  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()

  return (
    <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <CategoryHeader />
      <div className="mh-100-exact">
        <SearchCountNumber onClick={searchProductsFunc} title={`${items && items.length} search result`} />
        <Container>
          <Row className="d-flex flex-row">
            <Col md="3" xs="12" lg="2" className="d-flex">
              <SidebarFilter searchProductsFunc={searchProductsFunc} />
            </Col>
            <Col md="9" xs="12" lg="10" >
              {items && items.length >= 1 ? (
                <CardProductContainer products={items} />
              ) : (<div className='d-flex  align-items-center justify-content-center flex-column mh-100-exact'>
                <h3 className='alert alert-danger text-center px-5'>No Product with {localStorage.getItem("SearchValue")} </h3>
              </div>)}
            </Col>
          </Row>
        </Container>
      </div>
      {NumberOfPages && NumberOfPages > 1 ? (<Pagination pageCount={NumberOfPages} onPress={onPressPage} />) : null}
      <Footer />
    </>
  );
};

export default ShopProducts;